import './bootstrap';

$.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    }
});


// plugins
window.moment = require('moment');

window.dt = require('datatables.net-bs5');
window.select = require('datatables.net-select-bs5');

window.datepicker = require('bootstrap-datepicker');
window.datepickerLangPl = require('bootstrap-datepicker/js/locales/bootstrap-datepicker.pl');
window.datetimepicker = require('jquery-datetimepicker');
// jQuery.datetimepicker.setLocale('en');
window.select2 = require('select2');
// import Chart from 'chart.js/auto'; // window.chart = require('chart.js'); // import Chart from 'chart.js/auto'; // var Chart = require('chart.js/auto'); // via webpack.mix.js
window.chartBackgroundColor = ['rgba(255, 99, 132, 0.2)', 'rgba(54, 162, 235, 0.2)', 'rgba(255, 206, 86, 0.2)', 'rgba(75, 192, 192, 0.2)', 'rgba(153, 102, 255, 0.2)', 'rgba(255, 159, 64, 0.2)'];
window.chartBorderColor = ['rgb(255, 99, 132)', 'rgba(54, 162, 235, 1)', 'rgba(255, 206, 86, 1)', 'rgb(75, 192, 192)', 'rgba(153, 102, 255, 1)', 'rgba(255, 159, 64, 1)'];
// import bsCustomFileInput from 'bs-custom-file-input'
// bsCustomFileInput.init();

// window.tinymce = require('tinymce/tinymce'); // Import TinyMCE
// require('tinymce/icons/default'); // Default icons are required for TinyMCE 5.3 or above
// require('tinymce/themes/silver'); // A theme is also required
// require('tinymce/plugins/paste'); // Any plugins you want to use has to be imported
// require('tinymce/plugins/link');


// datatables
$.extend(true, $.fn.dataTable.defaults, {
    processing: true,
    serverSide: true,
    responsive: false,
    colReorder: true,
    autoWidth: true,
    pageLength: 100, // default 10
    lengthMenu: [ [10, 25, 50, 100, 250, 500, 1000], [10, 25, 50, 100, 250, 500, 1000] ], // -1 it's all // default 10, 25, 50, 100
    language: {
        url: '/lang/datatables-pl.lang',
    }
});

// multi selecting rows on table, after clicking on checkbox
// fired up on clicking checkbox
$.fn.dataTableExt.oApi.fnMultiSelectingRows = function (oSettings) {
    let table = $(oSettings.nTable);
    let api = oSettings.oInit;

    // filling up array with checked rows
    // toggled selected class on row after click
    $('tbody tr td i.cpt-dt-checkbox', table).on('click', function () {
        let id = $(this).data('id');
        let index = $.inArray(id, api.selectedIds);
        index === -1 ? api.selectedIds.push(id) : api.selectedIds.splice(index, 1);
        // toggle selecting checkbox
        $(this).closest('i').toggleClass('fa-square fa-check-square text-success');

        // toggle toggle checkbox
        // we have three state: nothing selected, all selected, something selected
        toggleToggleCheckbox(api);

        // display selected rows count
        displaySelectedCount(api, oSettings._iRecordsDisplay);
    });

    // holding Ctrl and left click mouse to toggle check order line
    $('tbody tr', table).on('click', function (e) {
        let localName = e.target.localName
        if (!e.originalEvent.ctrlKey || $.inArray(localName, ['i', 'a', 'button']) !== -1) {
            return;
        }

        let id = localName === 'span'
            ? e.target.parentElement.parentElement.attributes.getNamedItem('data-id').value
            : e.target.parentElement.attributes.getNamedItem('data-id').value;
        id = Number(id);

        let index = $.inArray(id, api.selectedIds);
        index === -1 ? api.selectedIds.push(id) : api.selectedIds.splice(index, 1);
        // toggle selecting checkbox
        $('tr td i[data-id="' + id + '"]', table).toggleClass('fa-square fa-check-square text-success');

        // toggle toggle checkbox
        // we have three state: nothing selected, all selected, something selected
        toggleToggleCheckbox(api);

        // display selected rows count
        displaySelectedCount(api, oSettings._iRecordsDisplay);
    });

    // checked checkboxes after each table draw: pagination, sorting, etc.
    $(table).find('i[data-id]').each(function () {
        let dataId = $(this).data('id');

        if ((api.selectAll && $.inArray(dataId, api.selectedIds) === -1) || (!api.selectAll && $.inArray(dataId, api.selectedIds) !== -1)) {
            $(table).find('i.cpt-dt-checkbox[data-id="' + dataId + '"]').removeClass('fa-square').addClass('fa-check-square text-success');
        }
    });

    displaySelectedCount(api, oSettings._iRecordsDisplay);
};

// select / unselect all - toggle
$.fn.dataTableExt.oApi.toggleSelectAll = function (oSettings, recordsDisplay) {
    let api = oSettings.oInit;
    api.selectedIds = [];

    if (api.selectAll) {
        api.selectAll = false;
        $('i.cpt-dt-checkbox-toggle').removeClass('fa-minus-square fa-check-square').addClass('fa-square');
        $('tbody tr td i.cpt-dt-checkbox').removeClass('fa-check-square text-success').addClass('fa-square')
    } else {
        api.selectAll = true;
        $('i.cpt-dt-checkbox-toggle').removeClass('fa-square fa-minus-square').addClass('fa-check-square');
        $('tbody tr td i.cpt-dt-checkbox').removeClass('fa-square').addClass('fa-check-square text-success');
    }

    displaySelectedCount(api, recordsDisplay);
};

/**
 * it's copy and expand of ellipsis
 */
jQuery.fn.dataTable.render.items = function ( cutoff, wordbreak, escapeHtml ) {
    let esc = function ( t ) {
        return t
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;');
    };

    let trimString = function ( t ) {
        return t.replace(/times/gi, '&times;').replace(/\n/gi, '<br>');
    };

    return function ( d, type, row ) {
        // Order, search and type get the original data
        if ( type !== 'display' ) {
            return d;
        }

        if ( typeof d !== 'number' && typeof d !== 'string' ) {
            return d;
        }

        d = d.toString(); // cast numbers

        if ( d.length <= cutoff ) {
            return trimString(d);
        }

        let shortened = d.substr(0, cutoff - 1);

        // Find the last white space character in the string
        if ( wordbreak ) {
            shortened = shortened.replace(/\s([^\s]*)$/, '');
        }

        // Protect against uncontrolled HTML input
        if ( escapeHtml ) {
            shortened = esc(shortened);
        }

        shortened = trimString(shortened);

        return '<span data-bs-toggle="tooltip" title="' + trimString(d) + '">' + shortened + '&#8230;</span>';
    };
};

jQuery.fn.dataTable.render.orderLines = function (cutoff, wordbreak, escapeHtml) {
    let combine = function (lines) {
        let toReturn = '';

        $.each(lines, function (index, row) {
            toReturn += row.quantity + 'x ' + row.name;

            if (row.sku != null && row.sku.length) {
                toReturn += ' | ' + row.sku;
            }

            toReturn += ' | ' + row.price;

            if (index < lines.length - 1) {
                toReturn += '<br>';
            }
        });

        return toReturn;
    }

    return function (data, type, row) {
        let toReturn = combine(data);

        if (toReturn.length <= cutoff) {
            return toReturn;
        }

        let shortened = toReturn.substring(0, cutoff - 1);

        return '<span data-bs-toggle="tooltip" title="' + toReturn + '">' + shortened + '&#8230;</span>';
    };
};

jQuery.fn.dataTable.render.shippingLines = function () {
    let combine = function (shippingLines) {
        let toReturn = '';

        $.each(shippingLines, function (index, row) {
            toReturn += row.quantity + 'x ' + row.method_title + ' | ' + row.price;

            if (index < shippingLines.length - 1) {
                toReturn += '<br>';
            }
        });

        return toReturn;
    }

    return function (data, type, row) {
        if (! Array.isArray(data)) {
            return '';
        }

        let toReturn = combine(data);

        return '<span data-bs-toggle="tooltip" title="' + toReturn + '"><i class="fa-solid fa-box-open" aria-hidden="true"></i></span>';
    };
};

jQuery.fn.dataTable.render.shippingLinesPackages = function () {
    let combine = function (shippingLines) {
        let toReturn = '';

        $.each(shippingLines, function (indexShippingLine, shippingLine) {
            $.each(shippingLine.packages, function (indexPackage, packageData) {
                if (packageData.is_canceled) {
                    return;
                }

                let quantity = shippingLine.is_divided ? 1 : shippingLine.quantity;
                toReturn += quantity + 'x ' + shippingLine.method_title + ' | ' + shippingLine.price;

                // if (indexPackage < packageData.length - 1) {
                    toReturn += '<br>';
                // }
            });
        });

        return toReturn;
    }

    return function (data, type, row) {
        if (! Array.isArray(data) || data.length === 0) {
            return '';
        }

        let toReturn = combine(data);

        if (toReturn.length === 0) {
            return '';
        }

        return '<span data-bs-toggle="tooltip" title="' + toReturn + '"><i class="fa-solid fa-box-open" aria-hidden="true"></i></span>';
    };
};

$.fn.showHide = function (show, selector) {
    show
        ? $(selector).removeClass('d-none')
        : $(selector).addClass('d-none');
};

/**
 * it's copy of number: $.fn.dataTable.render.number( '\'', '.', 0, '$' )
 */
$.fn.amountFormatter = function (d, thousands, decimal, precision, prefix, postfix) {
    if (typeof d !== 'number' && typeof d !== 'string') {
        return d;
    }

    let negative = d < 0 ? '-' : '';
    let flo = parseFloat(d);

    // If NaN then there isn't much formatting that we can do - just
    // return immediately, escaping any HTML (this was supposed to
    // be a number after all)
    if (isNaN(flo)) {
        return __htmlEscapeEntities(d);
    }

    flo = flo.toFixed(precision);
    d = Math.abs(flo);

    let intPart = parseInt(d, 10);
    let floatPart = precision ?
        decimal + (d - intPart).toFixed(precision).substring(2) :
        '';

    // If zero, then can't have a negative prefix
    if (intPart === 0 && parseFloat(floatPart) === 0) {
        negative = '';
    }

    return negative + (prefix || '') +
        intPart.toString().replace(
            /\B(?=(\d{3})+(?!\d))/g, thousands
        ) +
        floatPart +
        (postfix || '');
};

let __htmlEscapeEntities = function ( d ) {
    return typeof d === 'string' ?
        d
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;') :
        d;
};

function displaySelectedCount(api, recordsDisplay)
{
    let selector = 'div.dataTables_info span.cpt-dt-count-selected';

    if (!$(selector).length) {
        $('div.dataTables_info').append('<span class="mx-2 cpt-dt-count-selected"></span>');
    }

    let count = 0;

    if (!api.selectAll && api.selectedIds.length === 0) {
        $(selector).text('');
        toggleMassActionButtons(false);
    } else if (!api.selectAll) { // only selected
        count = Math.min(recordsDisplay, api.selectedIds.length);
        $(selector).text('Zaznaczono: ' + count);
        toggleMassActionButtons(true);
    } else if (api.selectAll && api.selectedIds.length === 0) { // all
        count = recordsDisplay;
        $(selector).text('Zaznaczono: ' + count);
        toggleMassActionButtons(recordsDisplay > 0);
    } else { // all - selected
        count = Math.max(0, recordsDisplay - api.selectedIds.length);
        $(selector).text('Zaznaczono: ' + count);
        toggleMassActionButtons(count > 0);
    }
}

function toggleToggleCheckbox(api)
{
    if (api.selectedIds && (api.selectAll || !api.selectAll)) {
        $('i.cpt-dt-checkbox-toggle').removeClass('fa-check-square fa-square').addClass('fa-minus-square');
    } else if (api.selectAll) {
        $('i.cpt-dt-checkbox-toggle').removeClass('fa-minus-square fa-square').addClass('fa-check-square');
    } else {
        $('i.cpt-dt-checkbox-toggle').removeClass('fa-minus-square fa-check-square').addClass('fa-square');
    }
}

function toggleMassActionButtons(enable)
{
    $(
        'button#mailing-campaigns-destroy, ' +
        'button#mailing-groups-destroy, ' +
        'button#mailing-subscribers-destroy, ' +
        'button#mailing-templates-destroy, ' +
        'button#order-colors-destroy,' +
        'button#order-statuses-destroy, ' +
        'button#orders-color-change, ' +
        'button#orders-delete-restore, ' +
        'button#orders-export, ' +
        'button#orders-parcels-send, ' +
        // 'button#orders-template-send, ' + // TODO: dodać wysyłanie szablonu do przefiltrowanych zamówień // https://youtrack.localhero.pro/issue/CPT-247
        'button#overall-dimensions-change-status, ' +
        'button#overall-dimensions-destroy, ' +
        'button#packages-cancel-mass-action, ' +
        'button#packages-collection-order, ' +
        'button#packages-create-mass-action, ' +
        'button#packages-destroy-mass-action, ' +
        'button#packages-labels-download, ' +
        'button#packages-labels-download-selected, ' +
        'button.orders-force-delete, ' +
        'button.tasks-delete'
    ).attr('disabled', !enable);

    // disable on trashed
    let orderStatusId = $('div#left-navigation a.list-group-item-secondary').data('id')
    $('button#orders-order-statuses-update, button#orders-parcels-send').attr('disabled', orderStatusId == -1 ? true : !enable)
}

$.fn.paidDirection = function (isPaid, paidDirection, total, paid) {
    if (!isPaid) {
        return '<i class="fas fa-euro-sign text-danger" data-bs-toggle="tooltip" title="Brak wpłaty!"></i>';
    } else if (paidDirection === '-') {
        return '<i class="fas fa-euro-sign text-warning" data-bs-toggle="tooltip" data-bs-html="true" title="Niedpopłata!<br>Zapłacono ' + paid + ' z ' + total + '."></i>';
    } else if (paidDirection === '=') {
        return '<i class="fas fa-euro-sign  text-success"></i>';
    } else if (paidDirection === '+') {
        return '<i class="fas fa-euro-sign text-info" data-bs-toggle="tooltip" data-bs-html="true" title="Nadpłata!<br>Zapłacono ' + paid + ' z ' + total + '."></i>';
    }

    return 'change-me';
};

$.fn.resetInit = function (dt) {
    dt.init().selectAll = false;
    dt.init().selectedIds = [];
};


// select2
$.fn.select2.defaults.set('theme', 'bootstrap-5');
$.fn.select2.defaults.set('language', 'pl');


// after DOM load
$(function () {
    // var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
    // var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
    //     return new bootstrap.Tooltip(tooltipTriggerEl)
    // })

    $('[data-bs-toggle="tooltip"]').tooltip({
        container: 'body',
    });

    $.fn.datepicker.defaults.format = 'dd.mm.yyyy';
    $.fn.datepicker.defaults.language = 'pl';
    $.fn.datepicker.defaults.autoclose = true;
    $.fn.datepicker.defaults.todayBtn = true;
    $.fn.datepicker.defaults.todayHighlight = true;
    $.fn.datepicker.defaults.clearBtn = true;
    $.fn.datepicker.defaults.startDate = '01-01-1901';
    $.fn.datepicker.defaults.endDate = '31-12-2155';

    // bsCustomFileInput.init();

    function tableFullWidth()
    {
        $('table').css('width', '100%');
    }

    function toggleTooltipLeftNavigation()
    {
        $(window).width() < 992
            ? $('div#left-navigation a i.main-icon, div.left-navigation a i.main-icon').addClass('main-icon-small')
            : $('div#left-navigation a i.main-icon, div.left-navigation a i.main-icon').removeClass('main-icon-small');
    }

    // Toggle main navigation
    let leftNavigation = 'a#leftNavigation-toggle';
    $(leftNavigation).on('click', function () {
        $('div#left-navigation')
            .toggleClass('d-sm-none')
            .toggleClass('d-md-none')
            .toggleClass('d-lg-block');

        $('div#left-navigation').hasClass('d-sm-none')
            ? $('#mainDiv')
                .removeClass('col-lg-12')
                .addClass('col-lg-10')
            : $('#mainDiv')
                .removeClass('col-lg-10')
                .addClass('col-lg-12');

        tableFullWidth();

        axios
            .patch('/users/session/settings/navigation/toggle')
            .then(response => {
                //
            });
    });

    toggleTooltipLeftNavigation();
    $(window).on('resize', function () {
        tableFullWidth();
        toggleTooltipLeftNavigation();
    });

    // keyboard navigation
    let disAllowedPlaces = ['textarea', 'input'];
    $('body').on('keypress', function (e) {
        let place = e.target.localName;

        if ($.inArray(place, disAllowedPlaces) === -1) {
            let keyCode = e.which;

            // <
            if (keyCode === 60 && $('a#order_previous').length) {
                let a = $('a#order_previous')[0];

                if ($.inArray('disabled', a.classList) === -1) {
                    a.click(); // previous order
                }
            }

            // >
            if (keyCode === 62 && $('a#order_next').length) {
                let a = $('a#order_next')[0];

                if ($.inArray('disabled', a.classList) === -1) {
                    a.click(); // next order
                }
            }

            // [
            if (keyCode === 91) {
                $(leftNavigation).trigger('click'); // hide / show left navigation
            }
        }
    });

    // Shared functionality for displaying - not generating - label related to the package
    $(document).on('click', 'a.packageGetLabel, button.packageGetLabel', function () {
        let button = $(this);
        let packageId = button.attr('data-id');
        button.addClass('disabled').html('<i class="fas fa-spinner fa-spin"></i> Przetwarzanie');

        axios
            .get('/packages/' + packageId + '/labels', {responseType: 'blob'})
            .then(response => {
                const url = window.URL.createObjectURL(new Blob([response.data], {type: 'application/pdf'}));
                const link = document.createElement('a');
                link.href = url;
                link.target = '_blank';
                link.click();
            })
            .catch(error => {
                $('.toast .toast-body').text('Zasób nie został odnaleziony.');
                $('.toast small.text-muted').text(moment().format('YYYY-MM-DD HH:mm:ss'));
                $('.toast').toast({autohide: false}).toast('show');
            })
            .finally(() => {
                button.removeClass('disabled').html('<i class="fas fa-file-download"></i> Pobierz etykietę');
            });
    });

    // Shared functionality for generating label related to the package
    $(document).on('click', 'a.packageGenerateLabel, button.packageGenerateLabel', function () {
        let button = $(this);
        let packageId = button.attr('data-id');
        button.addClass('disabled').html('<i class="fas fa-spinner fa-spin"></i> Przetwarzanie');

        axios
            .get('/packages/' + packageId + '/labels/generate')
            .then(response => {
                $('.toast .toast-body').text(response.data.message);
            })
            .catch(error => {
                $('.toast .toast-body').text(error.response.data.message);
            })
            .finally(() => {
                button.removeClass('disabled').html('<i class="fas fa-file-download"></i> Wygeneruj na nowo etykietę');
                $('.toast small.text-muted').text(moment().format('YYYY-MM-DD HH:mm:ss'));
                $('.toast').toast({autohide: false}).toast('show');
                // TODO: add table reload
            });
    });

    // TODO: not finished
    $(document).on('click', 'button.packageStore', function () {
        let button = $(this);
        let orderId = button.attr('data-order-id');
        button.addClass('disabled').html('<i class="fas fa-spinner fa-spin"></i> Przetwarzanie');
        let payload = {'orders': [orderId], 'carrier_sender_id': 10}; // TODO: pass carrier_id by attribute on button

        axios
            .post('/packages', payload)
            .then(response => {
                //
            });
    });

    // defuse
    $.fn.checkAuth = function (routeUrl) {
        return axios
            .post('/auth/check', {route: routeUrl})
            .then(response => {
                return response.data;
            })
            .catch(error => {
                return error.response.data;
            });
    }

    /**
     * @param e
     * @param thisTrigger button what trigger that method
     * @param messageConfirmation message for confirm the del
     * @param messageSuccess
     * @param URL
     * @param dtSelector
     */
    $.fn.deleteItem = function (e, thisTrigger, messageConfirmation, messageSuccess, URL, dtSelector) {
        e.preventDefault();

        if (confirm(messageConfirmation)) {
            // let button = thisTrigger;
            let id = thisTrigger.attr('data-id');
            let url = URL + id;
            thisTrigger.tooltip('dispose');
            let toReturn = true;

            return axios
                .delete(url)
                .then(response => {
                    let message = response.status === 204 ? messageSuccess : response.data.success
                    $('.toast .toast-body').html(message);
                    $('.toast').toast({autohide: true, delay: 3000}).toast('show');
                })
                .catch(error => {
                    $('.toast .toast-body').text(error.response.data.error);
                    $('.toast').toast({autohide: false}).toast('show');

                    toReturn = false;
                })
                .finally(() => {
                    $(dtSelector).DataTable().ajax.reload();
                    return toReturn;
                });
        } else {
            return false;
        }
    };

    $.fn.deleteItemsMassAction = function (e, thisTrigger, messageConfirmation, messageSuccess, URL, data, dtSelector) {
        e.preventDefault();

        if (confirm(messageConfirmation)) {
            // let button = thisTrigger;
            // let id = thisTrigger.attr('data-id');
            // let url = URL + id;
            thisTrigger.tooltip('dispose');

            axios
                .delete(URL, {data: data})
                .then(response => {
                    let message = response.status === 204 ? messageSuccess : response.data.message
                    $('.toast .toast-body').html(message);
                    $('.toast').toast({autohide: true, delay: 1500}).toast('show');
                })
                .catch(error => {
                    $('.toast .toast-body').text(error?.response?.data?.message ?? error.response.data.error);
                    $('.toast').toast({autohide: false}).toast('show');
                })
                .finally(() => {
                    $('.toast small.text-muted').text(moment().format('YYYY-MM-DD HH:mm:ss'));
                    $(dtSelector).DataTable().ajax.reload()
                });
        }
    };

    // send test email
    $.fn.sendTestEmail = function (e, button, data, url, alertSelector) {
        e.preventDefault();
        button.addClass('disabled').html('<i class="fas fa-spinner fa-spin"></i> Przetwarzanie');

        axios
            .post(url, data)
            .then(response => {
                $(alertSelector).addClass('alert-success').removeClass('alert-danger d-none').html(response.data.success);
            })
            .catch(error => {
                let msg = error.response.status === 422
                    ? 'Formularz zawiera błędy walidacji. Wymagane pola to: Temat, Wiadomość, E-mail.'
                    : error.response.data.error;

                $(alertSelector).addClass('alert-danger').removeClass('alert-success d-none').html(msg);
            })
            .finally(() => {
                button.removeClass('disabled').html('<i class="fas fa-paper-plane"></i> Wyślij wiadomość testową');
            });
    };

    $.fn.select2ColorsDropdownInit = function (placeholder, endpoint, selector, dropdownParent = 'body', selectionCss = null) {
        $(selector).select2({
            allowClear: true,
            placeholder: placeholder,
            dropdownParent: $(dropdownParent),
            selectionCssClass: selectionCss, // For Select2 v4.1
            ajax: {
                url: endpoint,
                data: function (params) {
                    return {
                        search: params.term,
                    };
                },
            },
            templateSelection: $.fn.formatColor,
            templateResult: $.fn.formatColor,
        });
    }

    $.fn.formatColor = function (orderColor) {
        if (!orderColor.color) {
            return orderColor.text;
        }

        return $('<span><i class="fas fa-square fa-2x" style="color: ' + orderColor.color + '"></i> ' + orderColor.text + '</span>');
    }

    // initialize default Select2 with search
    $.fn.defaultSelect2 = function (selector, url, placeholder, allowClear = false, dropdownParent = 'body', selectionCss = null) {
        $(selector).select2({
            placeholder: placeholder,
            allowClear: allowClear,
            dropdownParent: $(dropdownParent),
            selectionCssClass: selectionCss, // For Select2 v4.1
            ajax: {
                url: url,
                data: function (params) {
                    return {
                        search: params.term,
                    }
                },
            },
        });
    }

    // populate dropdown
    $.fn.getResource = function (endpoint) {
        return axios
            .get(endpoint)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                return error.response.data;
            });
    }

    // lines numbering by provided selector
    $.fn.lineReNumbering = function (selector) {
        $(selector).each(function (i, val) {
            $(val).text(i + 1);
        });
    }

    // default axios PUT request
    $.fn.defaultAxiosPut = function (url) {
        axios
            .put(url)
            .then(response => {
                $('.toast .toast-body').text(response.data.message);
                $('.toast').toast({autohide: true, delay: 1500}).toast('show');
            })
            .catch(error => {
                $('.toast .toast-body').html(error.message);
                $('.toast').toast({autohide: false}).toast('show');
            })
            .finally(() => {
                $('.toast small.text-muted').text(moment().format('YYYY-MM-DD HH:mm:ss'));
            });
    };

    // clear inputs by provided data id target
    $('.clear-inputs').on('click', function () {
        $($(this).data('id') + ' input').val(null);
        $($(this).data('id') + ' select').val(null).trigger('change');
    });

    // update left navigation orders counter
    $.fn.leftNavigationCounter = function () {
        axios
            .get('/orders/counters')
            .then(response => {
                let data = response.data;

                // set all to 0, then update with provided data
                $(
                    'div#left-navigation div#nav-orders a[data-type] span, ' +
                    'div.left-navigation div#nav-orders a[data-type] span'
                ).text(0);

                // update with provided data
                $(
                    'div#left-navigation div#nav-orders a[data-type="without-trashed-all"] span, ' +
                    'div.left-navigation div#nav-orders a[data-type="without-trashed-all"] span'
                ).text(data.without_trashed.all);
                $(
                    'div#left-navigation div#nav-orders a[data-type="trashed-all"] span, ' +
                    'div.left-navigation div#nav-orders a[data-type="trashed-all"] span'
                ).text(data.trashed.all);

                $.each(data.without_trashed.by_status, function (index, value) {
                    $(
                        'div#left-navigation div#nav-orders a[data-type="without-trashed-status-id-' + value.order_status_id + '"] span, ' +
                        'div.left-navigation div#nav-orders a[data-type="without-trashed-status-id-' + value.order_status_id + '"] span'
                    ).text(value.count);
                });
            });
    };

    // follow URL to show or edit on double-click on row on datatable
    $.fn.followUrl = function (selector, url, isOrders = false) {
        $(document).dblclick(selector, function (eventData, handler) {
            let localName = eventData.target.localName
            if ($.inArray(localName, ['i', 'a', 'button']) !== -1) {
                return;
            }

            let id = localName === 'span'
                ? eventData.target.parentElement.parentElement.attributes.getNamedItem('data-id').value
                : eventData.target.parentElement.attributes.getNamedItem('data-id').value;

            if (Math.floor(id) == id && $.isNumeric(id)) {
                if (isOrders) {
                    $('div#left-navigation div#nav-orders .list-group-item-secondary').data('id') == -1
                        ? window.open(url + id, '_self') // deleted // show
                        : window.open(url + id + '/edit', '_self'); // not deleted // edit
                } else {
                    window.open(url + id, '_self');
                }

                return false;
            }
        });
    };

    $.fn.packageCancelToggle = function (packageId) {
        return axios
            .put('/packages/' + packageId + '/cancel/toggle')
            .then(response => {
                $('.toast .toast-body').text('Ustawienia zostały zapisane.');
                $('.toast').toast({autohide: true, time: 3000}).toast('show');

                return response.data;
            })
            .catch(error => {
                $('.toast .toast-body').text(error.response.data.message);
                $('.toast').toast({autohide: false}).toast('show');

                return error.response.data;
            });
    }

    // copy to clipboard
    $(document).on('click', '.copy-to-clipboard', function () {
        let selector = $(this).data('selector');
        $(selector).select();    // Selects the text inside the input
        document.execCommand('copy');

        // tooltip
        $('.toast .toast-body').text('Skopiowano');
        $('.toast').toast({autohide: true, time: 1500}).toast('show');
    });

    $(document).on('click', '.copy-text', function () {
        let textToCopy = $(this).data('to-copy');

        if (isEmpty(textToCopy)) {
            textToCopy = '';
        }

        copyToClipboard(textToCopy);

        // tooltip
        $('.toast .toast-body').text('Skopiowano: ' + textToCopy);
        $('.toast').toast({autohide: true, time: 1500}).toast('show');
    });

    function copyToClipboard(textToCopy) {
        // navigator clipboard api needs a secure context (https)
        if (navigator.clipboard && window.isSecureContext) {
            // navigator clipboard api method
            return navigator.clipboard.writeText(textToCopy);
        } else {
            // text area method
            let textArea = document.createElement("textarea");
            textArea.value = textToCopy;
            // make the textarea out of viewport
            textArea.style.position = "fixed";
            textArea.style.left = "-999999px";
            textArea.style.top = "-999999px";
            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();
            return new Promise((res, rej) => {
                // here the magic happens
                document.execCommand('copy') ? res() : rej();
                textArea.remove();
            });
        }
    }

    function isEmpty(value) {
        return typeof value == 'string'
            && ! value.trim()
            || typeof value == 'undefined'
            || value === null;
    }
}); // $(function () {
